function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
import tasks from '@/js/tasks';
var appApisGTW = null;
if (!configuration['reports']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091') // "https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/reports/monitoring';
var DOMAIN_ACCESS = '/access';
var DOMAIN_ACCESS_LOG = '/access_log';
var CONTROLLER_BILLING_MONITORING = '/billing_monitoring';
var DOMAIN_REPORTS = '/reports';
export default {
  removeAccessTable: function removeAccessTable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS, "/remove"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getAccessLog: function getAccessLog() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS_LOG, "/list"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  viewAccess: function viewAccess() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS, "/viewAccess"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  viewAccessTable: function viewAccessTable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS, "/viewAccessTable"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  getBillingMonitoring: function getBillingMonitoring() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_BILLING_MONITORING).concat(DOMAIN_REPORTS, "/list"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  getBillingMonitoringById: function getBillingMonitoringById() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_BILLING_MONITORING).concat(DOMAIN_REPORTS, "/info"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  postBillingMonitoring: function postBillingMonitoring() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_BILLING_MONITORING).concat(DOMAIN_REPORTS, "/add_update"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  deleteBillingMonitoring: function deleteBillingMonitoring() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_BILLING_MONITORING).concat(DOMAIN_REPORTS, "/delete"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  incaMetrics: function incaMetrics() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/inca/metrics"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  myIncaMetrics: function myIncaMetrics() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/inca/my-metrics"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  }
};